import _ from "lodash";
// function created to avoid adding shallow-equal(double equals)
// code everywhere, where comparison is needed
export const isIdEqual = (id1, id2) => id1 == id2;

export const areIdsEqual = (...ids) => {
  // check if every id is equal to each other in ids array
  return _.every(ids, (id, index) => {
    return index === 0 || isIdEqual(id, ids[index - 1]);
  });
};
